import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { Table } from "lucide-react";


const Testing = () =>{
    const[idToUpdateDeleteTest,setIdToUpdateDeleteTest]= useState("");
    const[btnLabel,setBtnLabel] = useState("save");
    const{baseUrl}=useContext(AppContext);
    const[firstName,setFirstName] = useState("");
      const[lastName,setLastName] = useState("");
        const[file,setFile] = useState(null);
const[addUploadLoading,setAddUploadLoading] = useState(false);
const[testingRecords,setTestingRecords]= useState([]);


const uploadFileTest = () =>{
    const formData = new FormData();
    formData.append("firstName",firstName);
    formData.append("lastName",lastName);
    formData.append("file",file);
axios.post(`${baseUrl}/Tester/Testing/uploadFileTest`,
    formData,{
        headers:{
            "Content-Type":"multipart-formdata"
        }

    }).then((response)=>{
        console.log(response.data);
        setAddUploadLoading(false);
        viewAllUploadedFiles();
    }).catch((error)=>{
        console.log(error);
        setAddUploadLoading(false);
    })
}


const updateFileTest = () =>{
    const formData = new FormData();
    formData.append("id", idToUpdateDeleteTest);
    formData.append("firstName",firstName);
    formData.append("lastName",lastName);
    formData.append("file",file);
axios.post(`${baseUrl}/Tester/Testing/updateFileTest`,
    formData,{
        headers:{
            "Content-Type":"multipart-formdata"
        }

    }).then((response)=>{
        console.log(response.data);
        setAddUploadLoading(false);
        viewAllUploadedFiles();
    }).catch((error)=>{
        console.log(error);
        setAddUploadLoading(false);
    })
}

const deleteFileTest =(idToDelete)=>{
    console.log("***********");
    console.log(idToDelete);
    console.log("***********");
    const formData=new FormData();
    formData.append("id",idToDelete);
    axios.post(`${baseUrl}/Tester/Testing/deleteFileTest)`,
        formData,{
            headers:{"Content-Type":"multipart-formdata"

            }
        }).then((response)=>{
            console.log(response.data);
            viewAllUploadedFiles();

        }).catch((error)=>{
            console.log(error)
        })
        
}

const viewAllUploadedFiles=()=>{
axios.get(`${baseUrl}/Tester/Testing/viewAllUploadedFiles`

    ).then((response)=>{
        setTestingRecords(response.data.setTestingRecords)
    }).catch((error)=>{
        console.log(error)
    })
}

useEffect(()=>{
viewAllUploadedFiles()
},[])

    return(
        <>
        <Form.Control className="mt-3" placeholder="ENTER FIRST NAME"
        value={firstName}
        onChange={(event)=>{
            setFirstName(event.target.value)
        }}>
             
        </Form.Control>

        <Form.Control className="mt-3" placeholder="ENTER LAST NAME"
        value={lastName}
        onChange={(event)=>{
            setLastName(event.target.value)
        }}>
             
        </Form.Control>

        <Form.Control  type="file" className="mt-3" placeholder="ENTER FILE "
        //value={firstName}
        onChange={(event)=>{
            setFile(event.target.files[0])
        }}>
             
        </Form.Control>
        {addUploadLoading?<Spinner size="lg"/>:
        <Button onClick={()=>{
            setAddUploadLoading(true);
            if(btnLabel == "save"){
                console.log("SAVE CALLED");
                uploadFileTest();
            }else {
                        console.log("UPDATE CALLED");
                        //code for update
                        updateFileTest();
                    }

        }}
        className="mt-3">
{btnLabel}
        </Button>
}
        <Row>
            <Col lg={12}>
            <Table>
                <tr>
                    <th>ID</th>
                    <th>FIRST NAME</th>
                    <th>LAST NAME</th>
                    <th>FILE</th>
                    <th>ACTIONS</th>
                </tr>

                {testingRecords.map((item)=>{
                    return<tr>
                        <td>{item.id}</td>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item.file}</td>
                        <td><Button onClick={()=>{
                            setIdToUpdateDeleteTest(item.id);
                            setFirstName(item.firstName);
                            setLastName(item.lastName);
                            setBtnLabel("Update")
                        }}
                        variant="info">EDIT</Button>
                        <Button onClick={()=>{
                            deleteFileTest(item.id);
                        }} variant="danger">DELETE</Button></td>
                    </tr>
                })}
            </Table>
            
            </Col>


        </Row>
        </>
    )
}
export default Testing;